import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _548c67a8 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _f272577c = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _34852965 = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _7d9afb56 = () => interopDefault(import('../../../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _53c8e6b1 = () => interopDefault(import('../../../pages/philosophy.vue' /* webpackChunkName: "pages/philosophy" */))
const _4696103d = () => interopDefault(import('../../../pages/projects/index.vue' /* webpackChunkName: "pages/projects/index" */))
const _21af431e = () => interopDefault(import('../../../pages/services.vue' /* webpackChunkName: "pages/services" */))
const _7917319d = () => interopDefault(import('../../../pages/team.vue' /* webpackChunkName: "pages/team" */))
const _32ce881d = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _7be45a0e = () => interopDefault(import('../../../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _44df6ef5 = () => interopDefault(import('../../../pages/projects/_slug.vue' /* webpackChunkName: "pages/projects/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _548c67a8,
    name: "404___en"
  }, {
    path: "/bg",
    component: _f272577c,
    name: "index___bg"
  }, {
    path: "/blog",
    component: _34852965,
    name: "blog___en"
  }, {
    path: "/news",
    component: _7d9afb56,
    name: "news___en"
  }, {
    path: "/philosophy",
    component: _53c8e6b1,
    name: "philosophy___en"
  }, {
    path: "/projects",
    component: _4696103d,
    name: "projects___en"
  }, {
    path: "/services",
    component: _21af431e,
    name: "services___en"
  }, {
    path: "/team",
    component: _7917319d,
    name: "team___en"
  }, {
    path: "/bg/404",
    component: _548c67a8,
    name: "404___bg"
  }, {
    path: "/bg/blog",
    component: _34852965,
    name: "blog___bg"
  }, {
    path: "/bg/news",
    component: _7d9afb56,
    name: "news___bg"
  }, {
    path: "/bg/philosophy",
    component: _53c8e6b1,
    name: "philosophy___bg"
  }, {
    path: "/bg/projects",
    component: _4696103d,
    name: "projects___bg"
  }, {
    path: "/bg/services",
    component: _21af431e,
    name: "services___bg"
  }, {
    path: "/bg/team",
    component: _7917319d,
    name: "team___bg"
  }, {
    path: "/bg/blog/:slug",
    component: _32ce881d,
    name: "blog-slug___bg"
  }, {
    path: "/bg/novini/:slug",
    component: _7be45a0e,
    name: "news-slug___bg"
  }, {
    path: "/bg/proekt/:slug",
    component: _44df6ef5,
    name: "projects-slug___bg"
  }, {
    path: "/blog/:slug",
    component: _32ce881d,
    name: "blog-slug___en"
  }, {
    path: "/news/:slug",
    component: _7be45a0e,
    name: "news-slug___en"
  }, {
    path: "/project/:slug",
    component: _44df6ef5,
    name: "projects-slug___en"
  }, {
    path: "/",
    component: _f272577c,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
